module.exports = __webpack_public_path__ + "static/media/luke-skywalker.1ba7c487.jpg";